import { createContext } from "react";
import { IMillLocalserverLiveStatusContext } from "./MillLocalserverLiveStatusContextInterfaces";

export const initialState: IMillLocalserverLiveStatusContext = {
    loading: true,
    isDisconnected: false,
    error: undefined,
};

export const MillLocalserverLiveStatusContext = createContext(initialState);
